import { UserJWT } from '@/features/User/user.types'
import { deleteLocalStorage, getLocalStorage, setLocalStorage } from '@/shared/helpers/localStorage'
import { jwtDecode } from 'jwt-decode'

export function getUser(): UserJWT | null {
  if (typeof window === 'undefined') return null
  try {
    const userData = getLocalStorage('godefi:user')
    if (!userData) return null
    return JSON.parse(userData) as UserJWT
  } catch (error) {
    console.error('Failed to parse user from localStorage:', error)
    return null
  }
}

export function saveUser(user: { accessToken: string; refreshToken: string }) {
  try {
    if (!user?.accessToken || !user?.refreshToken) {
      throw new Error('Missing accessToken or refreshToken')
    }

    const decodedJWT = jwtDecode(user.accessToken)

    const fullUserData = {
      ...user,
      expireAt: decodedJWT.exp.toString(),
    }

    setLocalStorage('godefi:user', JSON.stringify(fullUserData))

    const saved = getLocalStorage('godefi:user')
    if (!saved) {
      throw new Error('Failed to verify user was saved to localStorage')
    }

    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('user:updated'))
    }
  } catch (error) {
    console.error('Error in saveUser:', error)
    throw error
  }
}

const AUTH_STORAGE_KEYS = [
  'godefi:user',
  'godefi:authStorage',
  'godefi:transactionStorage',
  'godefi:userStorage',
  'godefi:auth:rules',
  'godefi:card:rules:accepted',
  'godefi:country:accepted',
] as const

const WALLETCONNECT_STORAGE_PREFIX = '@appkit/'

function clearWalletConnectStorage() {
  if (typeof window === 'undefined') return

  Object.keys(localStorage)
    .filter((key) => key.startsWith(WALLETCONNECT_STORAGE_PREFIX))
    .forEach((key) => localStorage.removeItem(key))
}

export function clearAuthStorage() {
  AUTH_STORAGE_KEYS.forEach((key) => deleteLocalStorage(key))
  clearWalletConnectStorage()
}
